import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Input } from "../ui/Input";
import { Label } from "../ui/Label";
import { SignaturePad } from "./SignaturePad";

export function AgreementsStep() {
  const { register, control, watch } = useFormContext();

  const acceptanceSignature = watch("acceptanceSignature");
  const securitySignature = watch("securitySignature");
  const communicationSignature = watch("communicationSignature");
  const guaranteeSignature = watch("guaranteeSignature");

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <h3 className="text-lg font-medium border-b pb-2">Acceptance</h3>
        <p className="text-sm text-slate-600">
          I read and accept the Armellini Logistics Company Policies and
          Conditions of Contract and Carriage. Applicant's signature attests
          financial responsibility and willingness to pay invoices in accordance
          with terms. I/We authorize ARMELLINI EXPRESS LINES INC. (AEL) and my
          bank to verify the information supplied on this application and to
          receive information both now and in the future, with application.
        </p>
        <p className="text-sm text-slate-600">
          I/We hereby state that the foregoing information is true and correct.
          I/We agree to pay all bills in accordance with the terms of AEL or
          affiliated companies. I/We also agree in the event of default of
          payment which includes but are not limited to any and all, interest
          due, or to become due, together with any and all costs and expenses,
          (including but not limited to collection agency fees, attorney fees,
          and court costs) by AEL, or its affiliates or subsidiaries are the
          responsibility of the applicant.
        </p>
        <p className="text-sm text-slate-600">
          I/We have read, understand and accept the above terms and have
          provided true information to the best of my knowledge. I further
          authorize AEL to verify any and all references we have given that may
          be required to determine our credit capabilities and to request
          relevant information from credit reporting agencies.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4">
          <div className="space-y-2">
            <Label>Signature of authorized Officer <span className="text-red-500">*</span></Label>
            <Controller
              name="acceptanceSignature"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <SignaturePad
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </div>
          <div className="space-y-2">
            <Label>Date <span className="text-red-500">*</span></Label>
            <Input type="date" {...register("acceptanceDate", { required: true })} />
          </div>
          <div className="space-y-2 md:col-span-2">
            <Label>Print Name & Title <span className="text-red-500">*</span></Label>
            <Input {...register("acceptanceNameTitle", { required: true })} />
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-medium border-b pb-2">Security Interest</h3>
        <p className="text-sm text-slate-600 font-medium">
          Please be advised by signing below, you are granting Armellini (or its
          subsidiaries) a security interest.
        </p>
        <p className="text-sm text-slate-600">
          To secure payment for all invoices from Armellini (hereinafter Secured
          Party), now and in the future, Debtor (undersigned) herby grants
          Secured Party a continuing security interest in all of Debtor's
          presently owned or hereafter (a) goods, (b) instruments, (c) chattel
          paper, (d) books and records, (e) accounts, (f) accounts receivable,
          (g) general tangibles, and (h) payment intangibles and together with
          all proceeds and all support obligations thereof. The following
          constitute Debtor defaults: Non-payment in timely fashion of Debtor's
          indebtedness to Armellini, bankruptcy, insolvency, or assignment for
          the benefit of creditors; misrepresentation in respect of any
          provision of this or any Agreement between Armellini and Debtor. In
          the event of default, Armellini may declare all unpaid balances due.
          Debtor authorizes Secured Party to file a financing statement
          describing the collateral.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4">
          <div className="space-y-2">
            <Label>Signature of authorized Officer</Label>
            <Controller
              name="securitySignature"
              control={control}
              render={({ field }) => (
                <SignaturePad
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </div>
          <div className="space-y-2">
            <Label>Date {!!securitySignature && <span className="text-red-500">*</span>}</Label>
            <Input type="date" {...register("securityDate", { required: !!securitySignature })} />
          </div>
          <div className="space-y-2 md:col-span-2">
            <Label>Print Name & Title {!!securitySignature && <span className="text-red-500">*</span>}</Label>
            <Input {...register("securityNameTitle", { required: !!securitySignature })} />
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-medium border-b pb-2">
          Communication Consent
        </h3>
        <p className="text-sm text-slate-600">
          I understand that by providing my email address, mailing address, and
          fax number; I consent to receive communications sent by or on behalf
          of Armellini Logistics (and its subsidiaries and affiliates) via
          regular mail, email, telephone, or fax. I understand that Armellini
          Logistics will not share my address/email/telephone/fax with other
          organizations except when securing credit information.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4">
          <div className="space-y-2">
            <Label>Signature of authorized Officer</Label>
            <Controller
              name="communicationSignature"
              control={control}
              render={({ field }) => (
                <SignaturePad
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </div>
          <div className="space-y-2">
            <Label>Date {!!communicationSignature && <span className="text-red-500">*</span>}</Label>
            <Input type="date" {...register("communicationDate", { required: !!communicationSignature })} />
          </div>
          <div className="space-y-2 md:col-span-2">
            <Label>Print Name & Title {!!communicationSignature && <span className="text-red-500">*</span>}</Label>
            <Input {...register("communicationNameTitle", { required: !!communicationSignature })} />
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-medium border-b pb-2">
          Personal Guarantee of Indemnification
        </h3>
        <p className="text-sm text-slate-600 italic">
          (POTENTIAL FLOWER CUSTOMERS - SIGNATURE BELOW IS REQUIRED)
        </p>
        <p className="text-sm text-slate-600">
          We, the undersigned (jointly and severally) in consideration of the
          extension of credit do hereby unconditionally guarantee payment in
          full of all indebtedness, liabilities or obligations, said applicant
          shall at any time owe to Armellini Express Lines, Inc. or any of its
          subsidiaries or affiliated companies.
        </p>
        <p className="text-sm text-slate-600">
          This guarantee of indemnification shall be continuing, absolute, and
          unconditional and shall remain in full force and effect unless and
          until expressly revoked by a written notice from the undersigned, sent
          certified mail, return receipt requested, but shall continue to remain
          in effect until all said indebtedness, liabilities and obligations
          created before receiving such notice shall be paid in full.
        </p>
        <p className="text-sm text-slate-600">
          This guarantee extends to, and includes any and all, interest due, or
          to become due, together with any and all costs and expenses,
          (including but not limited to collection agency fees, attorney fees
          and court costs) by ARMELLINI EXPRESS LINES, INC. or its affiliates or
          subsidiaries in connection with any indebtedness covered by this
          guarantee.
        </p>
        <p className="text-sm text-slate-600">
          I/We hereby state that the foregoing information is true and correct.
          I/We agree to pay all bills in accordance with the terms of ARMELLINI
          EXPRESS LINES, INC. or affiliated companies. This indemnification
          agreement is binding upon the undersigned, our heirs, administrators
          and assigns.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4">
          <div className="space-y-2">
            <Label>Signature of authorized Officer</Label>
            <Controller
              name="guaranteeSignature"
              control={control}
              render={({ field }) => (
                <SignaturePad
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </div>
          <div className="space-y-2">
            <Label>Date {!!guaranteeSignature && <span className="text-red-500">*</span>}</Label>
            <Input type="date" {...register("guaranteeDate", { required: !!guaranteeSignature })} />
          </div>
          <div className="space-y-2 md:col-span-2">
            <Label>Print Name & Title {!!guaranteeSignature && <span className="text-red-500">*</span>}</Label>
            <Input {...register("guaranteeNameTitle", { required: !!guaranteeSignature })} />
          </div>
        </div>
      </div>
    </div>
  );
}
